module.exports = __webpack_public_path__ + "static/media/logoArtPerformanceDark.0f702d64.svg";